import axiosInstance from '@/plugins/axios';

// Tabelas de Incidência (genérico) — porte dos config-tabela (BFF). `tabela` = slug (fgts/cprp/inss/irrf/pispasep).
const base = (tabela) => `configuracoes/tabelas/incidencias/${tabela}`;

const ServiceTabelasIncidencia = {
  /** @param {string} tabela @param {*} body @param {{ page?: number, size?: number, sort?: string, signal?: AbortSignal }} [opts] */
  search: (tabela, body, { page = 0, size = 50, sort, signal } = {}) =>
    axiosInstance.post(`${base(tabela)}/search`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
      ...(signal ? { signal } : {}),
    }),
  filters: (tabela) => axiosInstance.get(`${base(tabela)}/filters`),
  exportData: (tabela, body) =>
    axiosInstance.post(`${base(tabela)}/export`, body ?? {}, { responseType: 'blob' }),
  exportarPersistido: (tabela, body) => axiosInstance.post(`${base(tabela)}/export`, body ?? {}),
  create: (tabela, body) => axiosInstance.post(base(tabela), body ?? {}),
  update: (tabela, code, body) =>
    axiosInstance.put(`${base(tabela)}/${encodeURIComponent(code)}`, body ?? {}),
  history: (tabela, code) =>
    axiosInstance.get(`${base(tabela)}/${encodeURIComponent(code)}/history`),
};

export default ServiceTabelasIncidencia;
